import { Alert, Button, Form, Input } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { appStore } from "src/appStore";
import { getErrorMessage, onError } from "src/common/onError";
import { ZLoginFormData } from "src/types/ZLoginFormData";

import { CommonOverlay } from "../CommonOverlay";
import * as styles from "./LoginPage.module.less";

export const LoginPage: React.FC = observer(() => {
  const [form] = Form.useForm<ZLoginFormData>();

  const handleSubmit = async (values: ZLoginFormData) => {
    try {
      await appStore.login(values.email, values.password);
      form.resetFields();
    } catch (error) {
      onError(error);
    }
  };

  return (
    <CommonOverlay title={t("Login")}>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        autoComplete="off"
        disabled={appStore.userData.status === "wait"}
      >
        <Form.Item
          name="email"
          label={t("Email")}
          rules={[
            {
              required: true,
              message: t("Please enter [field]", { field: t("Email") }),
            },
          ]}
        >
          <Input
            placeholder={t("Please enter [field]", { field: t("Email") })}
            size="large"
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={t("Password")}
          rules={[
            {
              required: true,
              message: t("Please enter [field]", { field: t("Password") }),
            },
          ]}
        >
          <Input.Password
            placeholder={t("Please enter [field]", { field: t("Password") })}
            size="large"
            autoComplete="password"
          />
        </Form.Item>

        {appStore.userData.status === "error" && (
          <Form.Item>
            <Alert
              type="error"
              showIcon
              {...getErrorMessage(appStore.userData.error)}
            />
          </Form.Item>
        )}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={appStore.userData.status === "wait"}
            size="large"
            className={styles.btn}
          >
            {t("Sign In")}
          </Button>
        </Form.Item>
      </Form>
    </CommonOverlay>
  );
});
